 function blockimage() {
    $('.cwib-blockimage.morethanone').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots:true,
      arrows:false,
       asNavFor: '.morethanonecontent'
    });
   $('.morethanonecontent').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots:false,
      arrows:false,
      asNavFor: '.morethanone'
    });
}
    blockimage();
jQuery(document).on("shopify:section:load", function() {
    blockimage();
});

$(document).ready(function(){
 

  $('.slider-testimon').slick({
 slidesToShow: 1,
  centerMode: true,
  centerPadding: "15%",
  autoplay: true,
  autoplaySpeed: 3000,
     dots:true,
      arrows:false,
    responsive: [
    {
      breakpoint: 600,
      settings: {
        centerPadding: "10%",
      }
    },
      ]
    
});
  });

$(window).on('scroll', function() {
  if($(window).scrollTop() >= $('footer.footer').offset().top + $('footer.footer').outerHeight() - window.innerHeight) {
    $('.collection-filter-type-main-wraper').addClass('hide-tea-type');
  }else{
    $('.collection-filter-type-main-wraper').removeClass('hide-tea-type');
  }
});


console.log('Dev==>RB');
jQuery('.first_selectbox_option_chnage_1').on("change", function(){

$('.first_selectbox_option_chnage_3 option').removeAttr("disabled");
option_check();
});

jQuery('.first_selectbox_option_chnage_2').on("change", function(){
option_check();
});
  
option_check();
  function option_check(){
    $('.first_selectbox_option_chnage_3 option').removeAttr("disabled");
jsonoption = {};
 $('.variant_option_main_select_box-custom option').each(function(){   
   var name =  $(this).data('varname');
   var available =  $(this).data('availabe');
   jsonoption[name] = available;
});

var first_val = $('.first_selectbox_option_chnage_1').val(); 
var second_val = $('.first_selectbox_option_chnage_2').val(); 
var get_first_select = '';
$('.first_selectbox_option_chnage_3 option').each(function(index){
    var thired_val = $(this).attr('value');    
    var created_option = first_val + ' / ' + second_val + ' / ' + thired_val;
    var getoption_array = jsonoption[created_option];
    if(getoption_array == 'no'){
      $(this).prop('disabled', 'disabled');
    }else if(getoption_array == undefined){
      $(this).prop('disabled', 'disabled');
    }else{
      if(get_first_select == ''){
        get_first_select = thired_val;
      }
    }
  }); 

if($('.first_selectbox_option_chnage_3').find('option:selected').is(':disabled')){
        if(get_first_select != ''){
          var new_class = 'select.first_selectbox_option_chnage_3';
          var sortBySelect = document.querySelector(new_class); 
          sortBySelect.value = get_first_select; 
          sortBySelect.dispatchEvent(new Event("change"));
        }
}else{
 console.log('working');  
}

}